export const PendingDocumentToolParameters = ({
  args,
}: {
  args: Record<string, unknown>;
}) => (
  <div role="region" aria-label="Proposed function call parameters">
    <pre className="m-0 max-h-80 overflow-auto whitespace-pre-wrap break-words rounded border border-gray-200 bg-gray-50 p-3 text-xs leading-5 text-gray-800">
      {JSON.stringify(args, null, 2)}
    </pre>
  </div>
);
